export default "__VITE_ASSET__BhpWTrxB__"